import api from './api';
import { BountyVerteilung, BountyAnteilInput } from '../types';

export const bountyService = {
  get: async (schwachstelleId: number): Promise<BountyVerteilung> => {
    const response = await api.get(`/schwachstellen/${schwachstelleId}/bounty`);
    return response.data;
  },

  update: async (
    schwachstelleId: number,
    anteile: BountyAnteilInput[]
  ): Promise<BountyVerteilung> => {
    const response = await api.put(`/schwachstellen/${schwachstelleId}/bounty`, { anteile });
    return response.data;
  },
};
